import React from "react";
import "../index.scss"
import { t } from "../../../../../utils/i18n";

const Head = () => (
  <thead className="onlinewalletspage-tablehead">
    <tr className="onlinewalletspage-tablehead-row">
      <th>{t("p2p.common.name")}</th>
      <th>{t("p2p.wallets.caption")}</th>
      <th>{t("p2p.wallets.url")}</th>
      <th className="onlinewalletspage-table-actions">{t("p2p.common.actions")}</th>
    </tr>
  </thead>
);

export default Head;
